/* ================================================== */
/* MENU
/* ================================================== */

var $toggle, $focus;

function toggleActive() {
	($(window).scrollTop() > 1) ? $toggle.addClass('header-toggle-active') : $toggle.removeClass('header-toggle-active');
}

$(document).ready(function() {

	// Inits
	var $header = $('#header'),
		$brandHeader = $('.header-brand', $header),
		$hamburger = $('.hamburger', $toggle),
		menu = '#menu',
		$menu = $(menu),
		$brandMenu = $('.header-brand', $menu),
		$columns = $('.menu-column-wrapper', $menu);
	$toggle = $('.header-toggle', $header);

	// Animations
	gsap.set($columns, { opacity: 0, y: '10%' });
	gsap.set($brandMenu, { opacity: 0, y: '-100%' });

	var tl = gsap.timeline();
	tl.to($brandHeader, 0.2, { opacity: 0, y: '-100%' })
		.fromTo($menu, 0.15, { opacity: 0, display: 'none' }, { opacity: 1, display: 'flex' })
		.to($brandMenu, 0.2, { opacity: 1, y: 0 })
		.to($columns, 0.2, { opacity: 1, y: 0, stagger: 0.15 })
		.pause();

	// Functions
	function openMenu() {
		$('body').addClass('overflow-hidden');
		$toggle
			.attr('aria-expanded', 'true')
			.removeClass('header-toggle-active');
		$hamburger.attr('data-open', 'true');

		// Animations
		tl.play();

		// Accessibility
		disableTabindex(menu);
		$('a[href]', $menu).attr('tabindex', '0');
		$menu.focus();
	}

	function closeMenu() {
		$('body').removeClass('overflow-hidden');
		$toggle.attr('aria-expanded', 'false');
		toggleActive();
		$hamburger.attr('data-open', 'false');

		// Animations
		tl.reverse();

		// Accessibility
		resetTabindex();
		$('a[href]', $menu).attr('tabindex', '-1');
		if (typeof $focus !== 'undefined' && $focus.length) $focus.focus();
	}

	// Toggle on click
	$toggle.click(function(event) {
		event.preventDefault();
		$focus = $(':focus');
		(!$menu.is(':visible')) ? openMenu() : closeMenu();
	});

	$(document).on('keyup', function(event) {
		// Toggle on “Enter”
		if (event.keyCode === 13 && $toggle.is(':focus')) {
			event.preventDefault();
			$focus = $(':focus');
			(!$menu.is(':visible')) ? openMenu() : closeMenu();
		}

		// Close on “Esc”
		if (event.keyCode === 27 && $menu.is(':visible')) {
			event.preventDefault();
			closeMenu();
		}
	});

	// Update style on scroll
	$(window).scroll(function() {
		toggleActive();
	});

});